import { useAuthUser } from './useAuthUser';

export function SignOutButton({ className }: { readonly className?: string }) {
  const { isAuthenticated, email, signOut } = useAuthUser();
  if (!isAuthenticated) return null;

  return (
    <div className={`sn-signout${className ? ` ${className}` : ''}`}>
      {email && <span className="sn-signout-email">{email}</span>}
      <button type="button" className="sn-signout-button" onClick={signOut}>
        Sign out
      </button>
    </div>
  );
}
